import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LocationAutocomplete = ({ onSelectCity }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  // New state: whether a city has been selected
  const [citySelected, setCitySelected] = useState(false);

  useEffect(() => {
    // If the query is too short or a city was just selected, clear suggestions.
    if (query.length < 3 || citySelected) {
      setSuggestions([]);
      return;
    }

    // Debounce the API call by 500ms
    const delayDebounceFn = setTimeout(() => {
      axios
        .get(`/api/autocomplete?input=${encodeURIComponent(query)}`)
        .then((response) => {
          // Expect the response to contain a 'predictions' array
          const predictions = response.data.predictions;
          setSuggestions(predictions || []);
        })
        .catch((err) => {
          console.error("Error fetching autocomplete suggestions:", err);
        });
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [query, citySelected]);

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    // When the user types, consider it a new query so allow suggestions to be fetched.
    setCitySelected(false);
  };

  const handleSelect = (prediction) => {
    setQuery(prediction.description);
    setSuggestions([]);
    // Mark that a city has been selected to prevent further suggestion fetching.
    setCitySelected(true);
    if (onSelectCity) onSelectCity(prediction);
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        placeholder="Enter city name..."
        className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-200"
      />
      {suggestions.length > 0 && (
        <ul className="absolute z-10 w-full bg-white border mt-1 max-h-60 overflow-y-auto rounded shadow">
          {suggestions.map((prediction, index) => (
            <li
              key={prediction.place_id || index}
              className="p-2 hover:bg-gray-200 cursor-pointer"
              onClick={() => handleSelect(prediction)}
            >
              {prediction.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LocationAutocomplete;
